import React, { useEffect, useContext, useState, Fragment } from 'react';
import axios from 'axios';
import { LoginContext } from '../../hooks/context/LoginContext';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Cookies from 'universal-cookie';
import { NavLink } from 'react-router-dom';
import { alertService } from '../../services/alertservice';
import { getApiUrl, axiosPost, getTitle, getDecodedCookie, handleOpenMenu, getNotificationsMenu } from '../../helpers/helperApp';

const url = window.location;

function MapNav(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
   
    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, logoMapNav, apiKey } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ loadedMenu, saveLoadedMenu ] = useState(false);
    const [ menu, saveMenu ] = useState(null);
   


    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{ 
                    document.title = getTitle(confPantalla.config.trad, confPantalla.index.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true); 
                        init();                        
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
            document.querySelector("body").classList.remove("sidebar-open");
            // Token cancelación axios al desmontar componentes
            source.cancel();    
        } 
        
    },[confPantalla])

    const init = async() => {                
        const resMenu = await readMenu();
        await getNotificationsMenu(resMenu, saveMenu);        
    }

    const readMenu = async () => {
        
        const nivelUsu =  getDecodedCookie('nivel');           
        const idiomaUsu =  getDecodedCookie('idioma');
        const idUsu = getDecodedCookie('id');                

        let res;
        let hayMenu = false;
        let resMenu = null;

        // Primero comprobamos si hay menú para ese id de usuario pero sin el nivel        
        try {
            res = await axios(url.origin+`/assets/_menu/_${idUsu}_0_${idiomaUsu}.json`);
            if(res){
                hayMenu = true; 
                resMenu = res.data.menu;               
                saveMenu(res.data.menu);
            }
        } catch (error) {
            console.log("No user menu")
        }

        // Segundo comprobamos si hay un menú para ese id de usuario con nivel
        if(!hayMenu){
            try {
                res = await axios(url.origin+`/assets/_menu/_${idUsu}_${nivelUsu}_${idiomaUsu}.json`);
                if(res){
                    hayMenu = true; 
                    resMenu = res.data.menu;                   
                    saveMenu(res.data.menu);
                }
            } catch (error) {
                console.log("No user_level menu")
            }
        }

        // Tecero comprobamos si hay un menú para ese nivel de usuario
        if(!hayMenu){
            try {
                res = await axios(url.origin+`/assets/_menu/_${nivelUsu}_${idiomaUsu}.json`);
                if(res){
                    hayMenu = true; 
                    resMenu = res.data.menu;                   
                    saveMenu(res.data.menu);
                }
            } catch (error) {
                console.log("No level menu")
            }
        } 
        saveLoadedMenu(true);
        return resMenu;             
    }
    

    return(
        <div className="App wrapper">            
        {
            confPantalla !== undefined
            ?                
                <Menusup 
                    props = { props }
                />                                    
            :
            null
        }
        {            
            confPantalla !== undefined
            ?                
                <Sidebar 
                    props = { props }
                />                
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header" style={{padding: "0px"}}>
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined && loadedMenu
                        ?     
                        <div class="container-fluid">
                            <div className="text-center">
                                <div className="h1"><img className="logo" style={{width: "175px"}} src={logoMapNav} /></div>
                            </div>
                            <div style={{display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "center"}}>
                                {
                                    menu.map((menuItem, index, menu) => {                                                                     
                                        let item = null;                                    
                                        if( menuItem.sub === "" ){
                                            item = 
                                                <div class="pl-2 pr-2 pb-2 pt-2">
                                                    {/* <div class="card mb-0" style={{minHeight: "12px", minWidth: "280px", border: "none"}}> */}
                                                    <div class="card mb-0" style={{minHeight: "12px", width: "320px", border: "none"}}>
                                                        <div class="card-body d-flex flex-column align-items-center justify-content-center text-center"
                                                             style={{padding: "0px 0px 0px 0px"}}
                                                        >
                                                                <NavLink 
                                                                    className={" btn btn-outline-primary mapnavlink"} 
                                                                    style={{
                                                                        width: "100%",
                                                                        border: "none",
                                                                        paddingLeft: "0px",
                                                                        paddingRight: "0px"
                                                                    }}
                                                                    data-href={menuItem.href} to={menuItem.href}
                                                                >
                                                                <i class={menuItem.icono+" fa-4x mb-3 mt-3"} style={{color: "inherit"}}></i>                                                
                                                                <h5 class="card-title pt-3 pb-3"
                                                                    style={{
                                                                        width: "100%", 
                                                                        marginBottom: "0px", 
                                                                        borderTop: "1px solid #007bff",
                                                                        borderTopLeftRadius: "0px", 
                                                                        borderTopRightRadius: "0px",
                                                                        wordWrap: "break-word"
                                                                    }}
                                                                >
                                                                    {menuItem.title}
                                                                </h5>                                                                
                                                                {
                                                                    menuItem.notifications != null && menuItem.notifications != 0
                                                                    ?
                                                                        <span 
                                                                            class={"right badge badgeMapNav badge-"+menuItem.color}
                                                                        >
                                                                            {menuItem.notifications}
                                                                        </span>
                                                                    :
                                                                        null
                                                                }
                                                                </NavLink>
                                                        </div>
                                                    </div>
                                                </div> 
                                            ;
                                        }else{
                                            item = 
                                                <div class="pl-2 pr-2 pb-2 pt-2">
                                                    {/* <div class="card mb-0" style={{minHeight: "12px", minWidth: "280px", border: "none"}}> */}
                                                    <div class="card mb-0" style={{minHeight: "12px", width: "320px", border: "none"}}>
                                                        <div class="card-body d-flex flex-column align-items-center justify-content-center text-center"
                                                             style={{padding: "0px 0px 0px 0px"}}
                                                        >                                                            
                                                            <div 
                                                                id={"btnMapNav-"+index}
                                                                onClick={ e => handleOpenMenu(e, index, null, true) }
                                                                className={" btn btn-outline-primary mapnavlink btnMapNav"} 
                                                                style={{
                                                                    width: "100%",
                                                                    border: "none",
                                                                    paddingLeft: "0px",
                                                                    paddingRight: "0px"
                                                                }}
                                                                data-href={menuItem.href} to={menuItem.href}
                                                            >
                                                                <i class={menuItem.icono+" fa-4x mb-3 mt-3"} style={{color: "inherit"}}></i>                                                
                                                                <h5 class="card-title pt-3 pb-3"
                                                                    style={{
                                                                        width: "100%", 
                                                                        marginBottom: "0px", 
                                                                        borderTop: "1px solid #007bff",
                                                                        borderTopLeftRadius: "0px", 
                                                                        borderTopRightRadius: "0px",
                                                                        wordWrap: "break-word"
                                                                    }}
                                                                >
                                                                    {menuItem.title}
                                                                </h5>
                                                                {
                                                                    menuItem.notifications != null && menuItem.notifications != 0
                                                                    ?
                                                                        <span 
                                                                            class={"right badge badgeMapNav badge-"+menuItem.color}                                                                    
                                                                        >
                                                                            {menuItem.notifications}
                                                                        </span>
                                                                    :
                                                                        null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>                                        
                                        }
                                        return(                                            
                                            item                                           
                                        )
                                    })
                                }
                            </div>
                        </div>                                                                
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default MapNav